// Invisible drag strips on the edges/corners of the stock modal (≥ sm only).
// Double-click any grip to reset to the default size.
//
// Sep 2026 — Right-side ('e') grip removed. It sat right on top of the
// vertical scrollbar and any attempt to grab the scrollbar was firing
// a resize instead. Left, top, bottom, and all four corners still
// resize normally.
const GRIPS = [
  ['w', 'top-4 bottom-4 left-0 w-1.5 cursor-ew-resize'],
  ['s', 'bottom-0 left-4 right-4 h-1.5 cursor-ns-resize'],
  ['n', 'top-0 left-4 right-4 h-1.5 cursor-ns-resize'],
  ['se', 'bottom-0 right-0 w-4 h-4 cursor-nwse-resize'],
  ['sw', 'bottom-0 left-0 w-4 h-4 cursor-nesw-resize'],
  ['ne', 'top-0 right-0 w-4 h-4 cursor-nesw-resize'],
  ['nw', 'top-0 left-0 w-4 h-4 cursor-nwse-resize'],
];

export default function ModalResizeGrips({ start, reset }) {
  return GRIPS.map(([edge, cls]) => (
    <div
      key={edge}
      role="separator"
      aria-orientation={edge.length === 1 && (edge === 'e' || edge === 'w') ? 'vertical' : 'horizontal'}
      onPointerDown={start(edge)}
      onDoubleClick={reset}
      title="Drag to resize · double-click to reset size"
      className={`hidden sm:block absolute z-[60] select-none touch-none hover:bg-primary/30 transition-colors ${cls}`}
      data-testid={`stock-modal-resize-${edge}`}
    />
  ));
}
